module.exports = __webpack_public_path__ + "img/dummyprod7@2x.fa939396.png";